import React from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import HeaderImage from '../components/header-image.component';
import { useNavigate } from 'react-router-dom';

const Home: React.FC = () => {
    const navigate = useNavigate();

    const handleDestinationPage = (destination: string) => {
        navigate(destination);
    };

    return (
        <div className="home-page d-flex flex-column mt-5">
            <Container>
                <Row className="mb-5 text-center">
                    <Col>
                        <HeaderImage />
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col xs={{ span: 8, offset: 2 }} md={{ span: 6, offset: 3 }} lg={{ span: 4, offset: 4 }}>
                        <Button
                            variant="light"
                            className="w-100 py-3 btn-lg greenButton rounded-pill"
                            onClick={() => handleDestinationPage("/accounts")}
                        >
                            Destination Accounts
                        </Button>
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col xs={{ span: 8, offset: 2 }} md={{ span: 6, offset: 3 }} lg={{ span: 4, offset: 4 }}>
                        <Button
                            variant="light"
                            className="w-100 py-3 btn-lg greenButton"
                            onClick={() => handleDestinationPage("/mywages")}
                        >
                            Access My Wages
                        </Button>
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col xs={{ span: 8, offset: 2 }} md={{ span: 6, offset: 3 }} lg={{ span: 4, offset: 4 }}>
                        <Button
                            variant="light"
                            className="w-100 py-3 btn-lg greenButton"
                            onClick={() => handleDestinationPage("/history")}
                        >
                            Payment History
                        </Button>
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col xs={{ span: 8, offset: 2 }} md={{ span: 6, offset: 3 }} lg={{ span: 4, offset: 4 }}>
                        <Button
                            variant="light"
                            className="w-100 py-3 btn-lg greenButton"
                            onClick={() => handleDestinationPage("/profile")}
                        >
                            Profile
                        </Button>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Home;